import React, { useEffect, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button, Input, Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { UserIcon, PWIcon } from '../Icon';
import { i18n } from '../../language';
import { authAPI, systemAPI } from '../../apis';
import { LOGIN_INFO } from '../../comm/constant';
import { updateLoginInfoAction } from '../../redux/actions';
import { IS_MOCK_API } from '../../comm/config';
import { updateUserRoleAction } from '../../redux/actions/userRole';
import { userRoleFunc, userRoleList } from '../../utils/userRole';
import { addLoginAction } from '../../utils/check';
import { alertMsg } from '../../apis/commlogic';
import { envFunc } from '../../utils/environments';
import { verFunc } from '../../utils/version';
import { mutationUpdateOtherLoginInfo } from '../../utils/handleUpdateOtherLoginInfo';

const LoginBtn = withStyles((theme) => ({
  root: {
    height: '3rem',
    borderRadius: '0.625rem',
    textTransform: 'none',
    fontSize: '1rem',
    backgroundColor: '#4c93ff',
    borderColor: '#4c93ff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    '&:hover': {
      backgroundColor: '#538FFF',
      borderColor: '#538FFF',
      boxShadow: 'none',
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '2.5rem',
  },
  paper: {
    width: '33.938rem',
    height: '30.625rem',
    position: 'relative',
    padding: '2.563rem 2.563rem 2.5rem 2.5rem',
    borderRadius: '0.937rem',
    boxShadow: '0 -6.3px 12px 0 rgba(0, 0, 0, 0.04)',
  },
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    color: '#5f9df6',
    marginRight: '0.5rem',
  },
  inputBox: {
    height: '3.5rem',
    padding: '0 1.063rem 0 1.125rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    marginBottom: '0.623rem',
    '& input': {
      color: '#525e6c',
      fontSize: '1rem',
      fontFamily: 'NotoSans-Medium',
    },
  },
  hintBottom: {
    marginTop: '1.5rem',
    textAlign: 'center',
    fontSize: '0.875rem',
    color: '#525e6c',
    fontFamily: 'NotoSans-Medium',
  },
  titleText: {
    color: '#001d63',
    fontWeight: 'bold',
    fontSize: '1.875rem',
    fontFamily: 'NotoSans-Bold',
  },
  logo: {
    fontFamily: 'NotoSans-Bold',
    color: '#001d63',
    fontSize: '0.875rem',
    fontWeight: 'bold',
  },
  grid: {
    height: '100%',
    justifyContent: 'space-between',
  },
  empty: {
    flexGrow: 1,
  },
  footA: {
    color: '#538fff',
  },
}));

function NorLogin({ submitClick, children, button, wardInfo, updateLoginInfo, rouList, userRole, updateUserRole }) {
  const classes = useStyles();
  const [LoginForm, setLoginForm] = React.useState({
    corpID: null,
    passcode: null,
  });

  const isMaxRoleHospIdEqualSetupHospId = (userRoleData) => {
    if (!userRoleFunc.isSuperAdmin(userRoleData)) {
      if (wardInfo.flag) {
        if (wardInfo.hospitalId !== userRoleFunc.getHospitalId(userRoleData)) {
          alertMsg(i18n.t('USER_HOSP_NO_SETUP_HOSP', { hospName: wardInfo.hospitalName }), _.uniqueId('error_'));
          return true;
        }
      } else if (userRoleData?.wards?.length === 0) {
        if (!userRoleFunc.isHospitalAdmin(userRoleData)) {
          alertMsg(i18n.t('USER_ROLE_0'), _.uniqueId('error_'));
          return true;
        }
      }
    }
    return false;
  };

  const setValueUseWardInfo = (roleData, maxRole) => {
    let result = { ...maxRole };
    if (!userRoleFunc.isSuperAdmin(roleData) && wardInfo.flag) {
      const wardInfoMaxRole = userRoleList.getMaxRoleUseHospIdAndWardId(roleData, wardInfo.hospitalId, wardInfo.wardId);
      if (wardInfoMaxRole) {
        result = {
          hospitalId: wardInfo.hospitalId ?? null,
          hospitalName: wardInfo.hospitalName ?? null,
          userId: wardInfoMaxRole?.userId ?? null,
          wardId: wardInfo.wardId ?? null,
          wardName: wardInfo.wardName ?? null,
          // roleId: wardInfoMaxRole?.roleId ?? null,
        };
      }
    }
    return result;
  };

  const handleSaveAndSkip = ({ userRoleData, userInfoData }) => {
    let filterHospUserRole = userRoleData;
    if (wardInfo?.flag && !userRoleList.isSuperAdmin(userRoleData)) {
      filterHospUserRole = userRoleList.filterHospWardUseHospId(userRoleData, wardInfo.hospitalId);
    }
    if (Array.isArray(filterHospUserRole) && filterHospUserRole.length !== 0) {
      const maxRole = userRoleList.maxLoginRole(filterHospUserRole);
      if (isMaxRoleHospIdEqualSetupHospId(maxRole)) return;
      if (maxRole) {
        let hospWard = {
          hospitalId: maxRole?.hospId ?? null,
          hospitalName: maxRole?.hospName ?? null,
          userId: maxRole?.userId ?? null,
          wardId: maxRole?.wards?.[0]?.wardId ?? null,
          wardName: maxRole?.wards?.[0]?.wardName ?? null,
          // roleId: maxRole?.roleId ?? null,
        };
        hospWard = setValueUseWardInfo(filterHospUserRole, hospWard);
        submitClick?.();
        updateLoginInfo({
          ...userInfoData,
          ...hospWard,
          flag: true,
        });
        localStorage.setItem(
          LOGIN_INFO,
          JSON.stringify({
            ...userInfoData,
            ...hospWard,
            flag: true,
          })
        );
        mutationUpdateOtherLoginInfo();
      }
      addLoginAction();
    } else {
      alertMsg(i18n.t('USER_HOSP_NO_SETUP_HOSP', { hospName: wardInfo.hospitalName }), _.uniqueId('error_'));
    }
  };

  const saveAndSkip = (userRoleData, userInfoData, result) => {
    if (Array.isArray(userRoleData) && userRoleData.length !== 0) {
      handleSaveAndSkip({ userRoleData, userInfoData });
    } else if (result?.length > 0) {
      alertMsg(
        i18n.t('ALERT_ACCOUNT_IS_NOT_AVAILABLE_FOR_LOGIN_PLEASE_CONTACT_ADMINISTRATOR_FOR_SUPPORT'),
        _.uniqueId('error_')
      );
    } else {
      alertMsg(i18n.t('USER_ROLE_0'), _.uniqueId('error_'));
    }
  };

  const submitClickHandle = async ({ corpID, passcode }) => {
    if (!corpID && !passcode) {
      alertMsg(i18n.t('ALERT_PLEASE_ENTER_THE_CORRECT_PASSWORD'), _.uniqueId('warning_'), 'warning');
      return;
    }
    if (IS_MOCK_API) {
      const corpIdMap = [
        'bxpenuser1',
        'bxpenuser2',
        'bxpenuser3',
        'bxpenuser4',
        'bxpenuser5',
        'bxpenuser6',
        'bxpenuser7',
      ];
      if (!corpIdMap.includes(corpID)) {
        corpID = corpIdMap[0];
      }
    }
    try {
      const { success, token, refreshToken, displayName, createTime, refreshTokenExp, tokenExp } = await authAPI.Login({
        corpID,
        passcode,
      });
      const temp = {
        corpID,
        token,
        refreshToken,
        displayName,
        createTime,
        refreshTokenExp,
        tokenExp,
      };
      if (success) {
        const { result } = await systemAPI.getSysUserRole({ corpId: corpID });
        const roleList = userRoleList.filterInActive(result);
        saveAndSkip(roleList, temp, result);
      } else {
        alertMsg(i18n.t('ALERT_CORP_ID_PASSWORD_IS_NOT_CORRECT_PLEASE_CHECK_AND_TRY_AGAIN'), _.uniqueId('error'));
      }
    } catch (error) {}
  };

  const keydownEvent = (e) => {
    const EnterCode = 13;
    if (EnterCode === e.keyCode) {
      (async () => {
        await submitClickHandle(LoginForm);
      })();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keydownEvent);
    return () => {
      document.removeEventListener('keydown', keydownEvent);
    };
  }, [LoginForm]);

  const loginFootRef = useRef(null);
  useEffect(() => {
    (async () => {
      let version = await verFunc.getVersion();
      const versionHtml = version ? `<br/> v${version}` : '';
      const elmA = document.createElement('a');
      elmA.setAttribute('href', await envFunc.getEnvLoginUrl());
      elmA.setAttribute('target', '_blank');
      elmA.setAttribute('class', classes.footA);
      elmA.setAttribute('id', 'login_support');
      elmA.innerText = i18n.t('LOGIN_BUSINESS_SUPPORT_DESK');
      loginFootRef.current.innerHTML = `${i18n.t(
        'LOGIN_IF_YOU_ENCOUNTER_ANY_PROBLEMS_PLEASE_USE__FOR_ASSISTANCE_FOR_URGENT_SUPPORT_AFTER_OFFICE_HOURS_PLEASE_CALL_IT_CALL_CENTRE_ON_2515_2653',
        { value: elmA.outerHTML }
      )} ${versionHtml}`;
    })();
  }, []);

  return (
    <div className={classes.root}>
      <Paper elevation={3} className={classes.paper}>
        <Grid container direction="column" className={classes.grid}>
          <Box display="flex" justifyContent="space-between" style={{ margin: '-0.85rem 0 2.188rem 0' }}>
            <Typography className={classes.titleText} gutterBottom>
              {i18n.t('LOGIN_TITLE')}
            </Typography>
            <span>{children}</span>
          </Box>
          <Input
            id="input-user"
            className={classes.inputBox}
            startAdornment={<UserIcon className={classes.icon} />}
            disableUnderline={true}
            placeholder={i18n.t('LOGIN_INPUT_USER')}
            onChange={(event) => {
              setLoginForm({ ...LoginForm, corpID: event.target.value });
            }}
          />
          <Input
            id="input-password"
            className={classes.inputBox}
            startAdornment={<PWIcon className={classes.icon} />}
            disableUnderline={true}
            placeholder={i18n.t('LOGIN_INPUT_PASSWORD')}
            focused="true"
            type="password"
            onChange={(event) => {
              setLoginForm({ ...LoginForm, passcode: event.target.value });
            }}
          />
          <div className={classes.empty} />
          <LoginBtn
            onClick={() => {
              (async () => {
                await submitClickHandle(LoginForm);
              })();
            }}
            id="login_button"
          >
            {button}
          </LoginBtn>
          <Typography className={classes.hintBottom} variant="body2" gutterBottom ref={loginFootRef} />
        </Grid>
      </Paper>
    </div>
  );
}

export default connect(
  (state) => ({
    loginInfo: state.loginInfo,
    userRole: state.userRole,
    rouList: state.rouList,
    wardInfo: state.wardInfo,
  }),
  {
    updateUserRole: updateUserRoleAction,
    updateLoginInfo: updateLoginInfoAction,
  }
)(withRouter(NorLogin));
